import { Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Button, Dialog, TextField, Typography } from "@platform/design-system";
import { useState } from "react";

import { MODAL_CONFIG, ScenarioModelModeType } from "../constants";

type ScenarioModelModalProps = {
  open: boolean;
  mode: ScenarioModelModeType;
  onClose: () => void;
  onExited?: () => void;
  defaultValueInput?: string;
  description?: string;
  onConfirm?: (value: string) => void;
  loading?: boolean;
};

export const ScenarioModelModal: React.FC<ScenarioModelModalProps> = ({
  open,
  mode,
  onClose,
  onExited,
  defaultValueInput = "Snapshot",
  description: descriptionOverride,
  onConfirm,
  loading = false,
}) => {
  const [input, setInput] = useState<string>(defaultValueInput);

  const {
    title,
    description: configDescription,
    confirmButtonLabel,
    inputLabel = "Model Name",
    showInput = true,
    additional,
  } = MODAL_CONFIG[mode];

  const description = descriptionOverride ?? configDescription;

  return (
    <Dialog
      onClose={onClose}
      open={open}
      title={title}
      maxWidth="xs"
      slotProps={{ transition: { onExited } }}
      actions={
        <>
          <Button
            data-testid="modal-cancel-button"
            onClick={onClose}
            variant="tertiary"
            disabled={loading}
          >
            Cancel
          </Button>
          <LoadingButton
            data-testid="modal-confirm-button"
            variant="contained"
            onClick={() => onConfirm?.(input)}
            loading={loading}
          >
            {confirmButtonLabel}
          </LoadingButton>
        </>
      }
      sx={{ "& .MuiDialogTitle-root": { fontWeight: 500 } }}
    >
      <Stack spacing={2} direction="column">
        <Typography variant="body-large" sx={{ whiteSpace: "pre-line" }}>
          {description}
        </Typography>

        {additional && (
          <Typography variant="body-large" sx={{ whiteSpace: "pre-line" }}>
            {additional}
          </Typography>
        )}

        {showInput && (
          <TextField
            label={inputLabel}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            disabled={loading}
          />
        )}
      </Stack>
    </Dialog>
  );
};
